import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reinsurance',
  templateUrl: './reinsurance.component.html',
  styleUrls: ['./reinsurance.component.css']
})
export class ReinsuranceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
